import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import RelayRenderer from '../relay/RelayRenderer';

type RelayConfig = {
  query: string,
  relayConfig: any,
  createContainer: () => {},
};

type ReduxConfig = {
  mapStateToProps: () => {},
  mapDispatchToProps?: () => {},
};

type ReduxFormConfig = {
  formConfig?: any,
};

type Config =
  | RelayConfig
  | ReduxConfig
  | ReduxFormConfig
  | {
      siteSelector: boolean,
    };

type RelayWrapperProps = {
  // TODO navigation
};

const RelayWrapper = ({
  container,
  query,
  renderLoading,
  variables: staticVariables,
}) => (props: RelayWrapperProps) => {
  const { match = {}, variables, ...rest } = props;

  return (
    <RelayRenderer
      {...rest}
      variables={{ ...staticVariables, ...match.params, ...variables }}
      query={query}
      container={container}
      renderLoading={renderLoading}
    />
  );
};

/*
https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
*/

const enhancer = (container, config: Config) => {
  const { mapStateToProps, mapDispatchToProps, form, relay } = config;

  let enhanced = container;

  if (!container) {
    throw new Error('Container cannot be null.');
  }

  if (relay) {
    const { create, variables = {}, query } = relay;

    if (query) {
      enhanced = RelayWrapper({
        container: create(),
        query,
        variables,
        renderLoading: relay.renderLoading,
      });
    } else {
      throw new Error('Missing Relay Query');
    }
  }

  if (form) {
    enhanced = reduxForm(form)(enhanced);
  }

  if (mapStateToProps || mapDispatchToProps) {
    enhanced = connect(mapStateToProps, mapDispatchToProps)(enhanced);
  }

  return hoistNonReactStatic(enhanced, container);
};

export default enhancer;



// WEBPACK FOOTER //
// ./src/components/enhancer.js